export const VALIDATION_TYPE = Object.freeze({
    ACCEPT_TERMS: 'acceptTerms',
    PIN_VERIFICATION: 'pinVerification',
    CHANGE_PASSWORD: 'changePassword',
    TWO_FACTOR_AUTHENTICATION: 'twoFactorAuthentication',
    MULTI_FACTOR_AUTHENTICATION: 'multiFactorAuthentication',
    FIT_TO_PLAY: 'fitToPlay'
});
